import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/live-streaming"
    path="business/products/live-streaming"
    element={<AsyncPage />}
  />,
];
